import { ArrowLeft, Mail, Book, HelpCircle, ChevronRight } from "lucide-react";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import welcomeBg from "../../assets/homebg.png";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";

const HelpSupportPage = () => {
  const navigate = useNavigate();

  const helpOptions = [
    {
      icon: Book,
      title: "Getting Started Guide",
      description: "Learn the basics of Bite Balance",
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      icon: HelpCircle,
      title: "FAQs",
      description: "Find answers to common questions",
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
    {
      icon: Mail,
      title: "Email Us",
      description: "support@bitebalance.com",
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
  ];

  return (
    <div
      className="scrollbar-hide relative mx-auto w-full max-w-[400px] bg-background"
      style={{
        minHeight: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Blurred Background Image */}
      <div
        className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-md"
        style={{
          backgroundImage: `url(${welcomeBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-background/80" />

      <div
        className="scrollbar-hide relative z-10 space-y-6 overflow-y-auto p-4 pb-16"
        style={{ height: "calc(100vh - 0px)" }}
      >
        {/* Header */}
        <div className="flex items-center gap-4 pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/glucera/profilepage")}
            className="rounded-xl bg-card/80 hover:bg-card"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-title2 font-bold text-foreground">Help & Support</h1>
        </div>

        <p className="text-subhead text-muted-foreground">
          We&apos;re here to help! Choose how you&apos;d like to get support.
        </p>

        {/* Help Options */}
        <div className="space-y-3">
          {helpOptions.map((option, index) => {
            const Icon = option.icon;
            return (
              <Card
                key={index}
                className="rounded-2xl border border-border bg-card p-4 shadow-lg"
              >
                <button
                  className="flex w-full items-center gap-4"
                  onClick={() => {
                    if (index === 0) {
                      navigate(
                        "/glucera" + GluceraNavigationRoutes.GETTING_STARTED
                      );
                    } else if (index === 1) {
                      navigate("/glucera" + GluceraNavigationRoutes.FAQS);
                    } else if (index === 2) {
                      navigate(
                        "/glucera" + GluceraNavigationRoutes.CONTACT_SUPPORT
                      );
                    }
                  }}
                >
                  <div
                    className={`flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl ${option.bgColor}`}
                  >
                    <Icon className={`h-6 w-6 ${option.color}`} />
                  </div>
                  <div className="min-w-0 flex-1 text-left">
                    <h3 className="font-semibold text-foreground">
                      {option.title}
                    </h3>
                    <p className="text-subhead text-muted-foreground">
                      {option.description}
                    </p>
                  </div>
                  <ChevronRight className="h-5 w-5 flex-shrink-0 text-muted-foreground" />
                </button>
              </Card>
            );
          })}
        </div>

        {/* App Version */}
        <div className="mt-8 space-y-2 text-subhead">
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">App Version</span>
            <span className="font-medium text-foreground">1.0.0</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Last Updated</span>
            <span className="font-medium text-foreground">Dec 24, 2025</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpSupportPage;
